import { FC, JSX, useEffect, useState } from "react";
import "./AccessProfilesList.scss";
import MasterPage from "../../../../pages/MasterPage/MasterPage";
import PageBase from "../../../../components/PageBase/PageBase";
import SkeletonTable from "../../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../../providers/PaginateProvider";
import { useAccessProfile } from "../../../../providers/Access/AccessProfile/AccessProfileProvider";
import moment from "moment";
import { AccessProfileModel } from "../../../../models/Access/AccessProfile/AccessProfileModel";
import ModalAccessProfilesInsert from "../../../../components/Access/AccessProfiles/ModalAccessProfilesInsert/ModalAccessProfilesInsert";
import SidebarAccessProfilesFilter from "../../../../components/Access/AccessProfiles/SidebarAccessProfilesFilter/SidebarAccessProfilesFilter";
import { useSidebarFilter } from "../../../../providers/SidebarFilterProvider";
import ModalAccessProfileLevelInsert from "../../../../components/Access/AccessProfiles/ModalAccessProfileLevelInsert/ModalAccessProfileLevelInsert";
import ModalAccessProfilePartnerPermission from "../../../../components/Access/AccessProfiles/ModalAccessProfilePartnerPermission/ModalAccessProfilePartnerPermission";

interface AccessProfilesListProps { }

const AccessProfilesList: FC<AccessProfilesListProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [showModalProfileLevelInsert, setShowModalProfileLevelInsert] =
    useState<boolean>(false);
  const [showModalPartnerPermission, setShowModalPartnerPermission] =
    useState<boolean>(false);
  const [accessProfileId, setAccessProfileId] = useState<number>(0);
  const { handlePaginate } = usePaginate();
  const {
    accessProfiles,
    setAccessProfile,
    pages,
    params,
    setParams,
    isLoading,
    error,
    handleList,
    handleDelete,
  } = useAccessProfile();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  const handleEdit = (item: AccessProfileModel) => {
    setAccessProfile(item);
    setShowModalInsert(true);
  };

  const handleAccessLevel = (item: AccessProfileModel) => {
    setAccessProfileId(item?.id ? item?.id : 0);
    setShowModalProfileLevelInsert(true);
  };

  const handleDeleteAccessProfilesList = (item: AccessProfileModel) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir o Nível de Acesso ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Nível de Acesso inativado com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar o Nível de Acesso.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {accessProfiles?.length > 0 ? (
          <>
            {accessProfiles.map((x: AccessProfileModel, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td>{x?.name}</td>
                <td>{x?.description}</td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    <Dropdown.Item
                      className="border-radius-md py-2"
                      onClick={() => handleEdit(x)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" /> Editar
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="border-radius-md py-2"
                      onClick={() => handleAccessLevel(x)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" /> Editar
                      Atribuições de acesso
                    </Dropdown.Item>
                    {!x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleDeleteAccessProfilesList(x)}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                        Remover
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={6} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>

            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Descrição
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {accessProfiles?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    setParams({ ...params, page: 1, filter: { only_active: false } });
  }, []);

  return (
    <MasterPage title="Níveis de Acessos" icon="fas fa-file" footerFixed>
      <div className="AccessProfilesList" data-testid="AccessProfilesList">
        <PageBase
          title="Níveis de Acessos"
          subtitle="Gerenciamentos dos níveis de acessos do sistema."
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
          useButtonGroup
          renderBtnAux={
            <button
              type="button"
              className="btn btn-outline-primary btn-sm mb-0"
              onClick={() => setShowModalPartnerPermission(true)}
            >
              Atribuir por Parceiro
            </button>
          }
        />

        <ModalAccessProfilesInsert
          show={showModalInsert}
          onClose={() => setShowModalInsert(false)}
        />

        <ModalAccessProfileLevelInsert
          show={showModalProfileLevelInsert}
          onClose={() => {
            setShowModalProfileLevelInsert(false);
            setAccessProfileId(0);
          }}
          accessProfileId={accessProfileId}
        />

        <ModalAccessProfilePartnerPermission
          show={showModalPartnerPermission}
          onClose={() => setShowModalPartnerPermission(false)}
        />
      </div>

      <SidebarAccessProfilesFilter />
    </MasterPage>
  );
};

export default AccessProfilesList;
